import { setUnreadListFailed, setUnreadListPending, setUnreadListSucceed } from './actions';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchChatsV2, IFetchChatsV2ParamsRequest } from '../../services/chatsList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { getPageStateLogData } from '../../utils/getPageStateLogData';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { IChatListRequest } from '../chatList/types';
import { setRoute } from '../route';

/**
 * Получить список непрочитанных чатов
 * FIXME: Пока ручки для получения всех непрочитанных нет, берем из обычных чатов
 */
export const getUnreadChatsV2 =
  ({ timestamp, trigger }: IChatListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setUnreadListPending({ timestamp }));

    const { status, filterBy } = getQueryParamsFetchChatsList(ERoute.Unread);

    const parameters: IFetchChatsV2ParamsRequest = {
      timestamp,
      subAgentRealtyUserId,
      status,
      filterBy,
    };

    const unreadChats = await fetchChatsV2(context, {
      parameters,
      logData: getPageStateLogData(state, trigger),
    });

    if (!unreadChats) {
      dispatch(setUnreadListFailed());

      return;
    }

    dispatch(setUnreadListSucceed(unreadChats));

    /**
     * Ставим активный пункт меню - сообщения
     */
    dispatch(setRoute({ route: ERoute.Unread }));
  };
